"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Facebook = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      width: '10px',
      height: '10px'
    }
  };
});

var Facebook = function Facebook(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    viewBox: "0 0 10 10"
  }, props, {
    classes: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.79995 0.600586L5.70998 0.602241C4.42618 0.649557 3.39995 1.70523 3.39995 3.00059V3.80059H2.59995C2.37904 3.80059 2.19995 3.97967 2.19995 4.20059V5.80059L2.20264 5.84723C2.22575 6.04617 2.39482 6.20059 2.59995 6.20059H3.39995V9.00059C3.39995 9.2215 3.57904 9.40059 3.79995 9.40059H5.39995L5.4466 9.39789C5.64553 9.37479 5.79995 9.20572 5.79995 9.00059V6.20059H6.59995C6.7835 6.20059 6.94349 6.07567 6.98801 5.8976L7.38801 4.2976L7.39655 4.25318C7.42842 4.01722 7.24487 3.80059 6.99995 3.80059H5.79995V3.00059H6.99995C7.22086 3.00059 7.39995 2.8215 7.39995 2.60059V1.00059C7.39995 0.779672 7.22086 0.600586 6.99995 0.600586H5.79995ZM6.59995 1.40059V2.20059H5.79995C5.35812 2.20059 4.99995 2.55876 4.99995 3.00059V4.20059L5.00264 4.24723C5.02575 4.44617 5.19482 4.60059 5.39995 4.60059H6.48715L6.28715 5.40059H5.39995L5.3533 5.40328C5.15437 5.42638 4.99995 5.59545 4.99995 5.80059V8.60059H4.19995V5.80059L4.19726 5.75394C4.17415 5.555 4.00509 5.40059 3.79995 5.40059H2.99995V4.60059H3.79995C4.02087 4.60059 4.19995 4.4215 4.19995 4.20059V3.00059C4.19995 2.11693 4.9163 1.40059 5.79995 1.40059H6.59995Z",
    fill: "black"
  }));
};

exports.Facebook = Facebook;